import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class MCPServerDTO  {
    _originalTypeClassName = "zvelton_Backoffice.BO.MCPServerDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
MCPServerDTO.translate = translateService;
}
this.Id = null;
this.Name = null;
this.URL = null;
this.Transport = null;
this.Enabled = false;
this.Auth_Basic_UserName = null;
this.Auth_Basic_Password = null;
this.Auth_ApiKey_Value = null;
this.Auth_ApiKey_Header = null;
this.Auth_ForwardHeader_Name = null;
this.AuthType = null;
this.MCPServerDTOKey = null;
this._key = this.MCPServerDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Name:any;
URL:any;
Transport:any;
Enabled:any;
Auth_Basic_UserName:any;
Auth_Basic_Password:any;
Auth_ApiKey_Value:any;
Auth_ApiKey_Header:any;
Auth_ForwardHeader_Name:any;
AuthType:any;
private _MCPServerDTOKey:any;
get MCPServerDTOKey(): any {
    return this._MCPServerDTOKey;
  }
set MCPServerDTOKey(value: any) {
    this._MCPServerDTOKey = value;
    this._key = value;
  }

static ToAgentDTO(server: any): any{let dto = new Domain.MCPServerDTO();
dto.Id = server?.Id;
dto.Name = server?.Name;
dto.URL = server?.URl;
dto.Transport = server?.Transport;
dto.Enabled = server?.Enabled;
if (server?.AuthType == Domain.MCP_AuthenticationType.Basic) {dto.Auth_Basic_UserName = server?.Auth_Basic_UserName;dto.Auth_Basic_Password = server?.Auth_Basic_Password;}else if (server?.AuthType == Domain.MCP_AuthenticationType.ApiKey) {dto.Auth_ApiKey_Value = server?.Auth_ApiKey_Value;dto.Auth_ApiKey_Header = server?.Auth_ApiKey_Header;}else if (server?.AuthType == Domain.MCP_AuthenticationType.ForwardHeader) {dto.Auth_ForwardHeader_Name = server?.Auth_ForwardHeader_Name;}
dto.AuthType = server?.AuthType;
return dto;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.MCPServerDTOKey == null || $this.MCPServerDTOKey == 0;
            }


}